import React from 'react';
import MemberSignUp, { type MemberSignUpProps } from '../../../react4xp/components/MemberSignUp'

function MemberSignupPart (props: MemberSignUpProps) {
  return (
    <MemberSignUp {...props} />
  )
}

export default (props: MemberSignUpProps) => <MemberSignupPart {...props} />
